import React from 'react'
import { Card, CardColumns } from 'react-bootstrap';
import { DataTable } from '../widgets';
import { formatNumber, Unit } from '../../helpers/unit';

const LogisticsSummary = ({ isRequesting: seedHistoryRequesting, data }) => {
	const unit = Unit.getInstance();

	const getLoadCapacity = (value) => {
		value = (value && value.toString().includes(',')) ? value.replace(/,/g, '') : value;
		return formatNumber(unit.toFixedOf(unit.toWeight(value, 2), 0));
	}

	return (
		<CardColumns>
			{
				Object.keys(data).map((type, index) => {
					let { title, header, body } = data[type];
					return (!['seedHistory', 'tareLoads'].includes(type)) && <div key={index}>
						<Card className='mt-3'>
							<Card.Body className='p-0'>
								<div className="text-center m-2 font-weight-bold">{title}</div>
								<DataTable>
									<DataTable.Header >
										<DataTable.Row>
											{header.map(item => <DataTable.Cell key={item.key} width={item.width}>{item.label}</DataTable.Cell>)}
										</DataTable.Row>
									</DataTable.Header>
									<DataTable.Body>
										{!seedHistoryRequesting && body.map((cellItem, index) => <DataTable.Row key={index}>
											{header.map(item => <DataTable.Cell
												key={item.key}
												width={item.width}
												style={cellItem[item.key] === "Unknown" ? { color: "red" } : {}}
											>
												{item.key === 'load_capacity' ? getLoadCapacity(cellItem[item.key]) : cellItem[item.key]}
											</DataTable.Cell>)}
										</DataTable.Row>)}
									</DataTable.Body>
								</DataTable>
								<div>
									{
										seedHistoryRequesting
											? <DataTable.Loading className="my-3" />
											: data[type].body.length === 0 && <DataTable.RecordsNotFound className="my-3" />
									}
								</div>
							</Card.Body>
						</Card>
					</div>
				})
			}
		</CardColumns>
	)
}

export default LogisticsSummary